import axios from "axios";

const coingecko = axios.create({
  baseURL: "https://api.coingecko.com/api/v3/coins/binance-smart-chain/contract",
});

export default coingecko;